<section class="home-screen">
  <div class="layout-container home-content">
    <header class="hero">
      <h1>AI-Powered Crisis<br />Exercise Design</h1>
      <p class="hero-copy">
        Build professional tabletop exercises powered by Gemini, Claude, and
        Mistral AI - tailored to your organization in minutes, not weeks.
      </p>
    </header>

    <section class="notice" aria-label="disclaimer">
      <div class="notice-icon">i</div>
      <p>
        For training and exercise design purposes only. All generated content is
        fictional and does not represent real events or organizations.
      </p>
    </section>

    <section class="modes" aria-labelledby="mode-title">
      <div class="section-copy">
        <h2 id="mode-title">Choose Your Mode</h2>
        <p>Select how you'd like to design your exercise today.</p>
      </div>

      <div class="card-row">
        <article class="mode-card" *ngFor="let card of cards">
          <div
            class="card-illustration"
            [attr.data-variant]="card.illustration"
          >
            <div class="illustration-orbit"></div>

            <div
              class="art art-analytics"
              *ngIf="card.illustration === 'analytics'"
            >
              <div class="window-bar"></div>
              <div class="chart chart-bars">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="chart chart-donut"></div>
              <div class="chart chart-line"></div>
            </div>

            <div class="art art-studio" *ngIf="card.illustration === 'studio'">
              <div class="phone"></div>
              <div class="dashboard">
                <div class="dashboard-top"></div>
                <div class="dashboard-chart"></div>
              </div>
              <div class="video"></div>
              <div class="mail"></div>
            </div>

            <div class="art art-mobile" *ngIf="card.illustration === 'mobile'">
              <div class="phone-shell">
                <div class="phone-grid">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <h3>{{ card.title }}</h3>
            <p class="subtitle">{{ card.subtitle }}</p>
            <p class="description">{{ card.description }}</p>
          </div>

          <button
            type="button"
            class="card-action"
            (click)="startExercise(card.title)"
          >
            {{ card.buttonLabel }}
          </button>
        </article>
      </div>
    </section>
  </div>
</section>
